const mobileWidth = '1000px';
// Up to here the 16rem sidebar still sits beside the content yet leaves it under ~1000px: wide enough
// for the desktop chrome, too narrow for a side rail or a 3rem gutter next to it.
const compactWidth = '1350px';

const colors = {
  primaryColor: '#3f7bb1',
  primaryColor2: '#438f9c',
  secondaryColor: '#109d68',
  secondaryColor2: '#82929B',
  tertiaryColor: '#15A1E2',
  quaternaryColor: '#F4974C',
  lightBlue: '#DBE9FF',
  // A paler tint of primaryColor, kept distinct from lightBlue: on the PM project page lightBlue already
  // means "AI-suggested, awaiting review", and the schedule calendar needs a blue of its own.
  milestoneBlue: '#E3EDF9',
  brightBlue: '#0B32FF',
  skyBlue: '#15A1E2',
  primaryColorTransparent: 'rgba(28, 61, 147, 0.5)',
  red1: '#950E2B',
  red2: '#CE031B',
  red3: '#EE4266',
  red4: '#F37C96',
  red5: '#F8B4C3',
  red6: '#FCD7D7',
  red7: '#EE3939',
  teal1: '#448F9C',
  grey1: '#242A2D',
  grey2: '#3E484E',
  grey3: '#656366',
  grey4: '#82929B',
  grey5: '#C7CCCE',
  grey6: '#D2D7DB',
  grey7: '#E8EBED',
  grey8: '#F4F5F6',
  grey9: '#F9FAFA',
  white: '#FFFFFF',
  black: '#000000',
  green: '#008800',
  green2: '#039600',
  green3: '#81DD74',
  orange: '#F4974C',
};

export const css = {
  ...colors,
  fontFamily: 'Jost',
  backgroundColor: '#FFFFFF',
  borderColor: colors.grey6,
  border: `1px solid ${colors.grey6}`,
  inputBackgroundColor: '#FFFFFF',
  inputBorder: `1px solid ${colors.black}`,
  inputFocusedBorder: `1px solid ${colors.primaryColor}`,
  inputBorderRadius: '0.5rem',
  inputHeight: '3rem',
  borderRadius: '1.5rem',
  appHeaderHeight: '3.5rem',
  mobileWidth: mobileWidth,
  mobileMedia: `@media only screen and (max-width: ${mobileWidth})`,
  desktopMedia: `@media only screen and (min-width: ${mobileWidth})`,
  compactMedia: `@media only screen and (max-width: ${compactWidth})`,
  flexVerticalCenter: 'display: flex; flex-direction: column; justify-content: space-around;',
  // Dark navigation chrome. Named tokens rather than greys inline, so the scheme retunes in one place
  // instead of across Nav.tsx's two styled blocks.
  navBackground: colors.grey1,
  navSurface: colors.grey2,      // hover and selected rows
  navBorder: colors.grey2,
  navText: colors.white,
  navHeightMobile: '3.5625rem',
  mobileNavWidth: '18rem',
  footerNavHeight: '3.75rem',
};